


















































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import constants from "../../config/constants";
import rules from "../../utils/rules";
import { trunc, formatPrice } from "../../utils/general-functions";
import Divider from "../../components/common/Divider.vue";

@Component({
  components: {
    Divider
  }
})
export default class Budget extends Vue {
  selectedProducts: Array<any> = [];
  valid = true;
  loadingGenerate = false;
  email = "";
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;
  loadingDialog = false;

  private get emailRules() {
    return [
      (v: any) =>
        /.+@.+\..+/.test(v) || this.$t("TERM-CLIENT-BUDGET-EMAIL-RULE")
    ];
  }

  private get costRules() {
    return [
      rules.positive,
      (v: any) =>
        (v && v.length > 0) || this.$t("TERM-CLIENT-BUDGET-NOTEMPTY-RULE")
    ];
  }

  $refs!: {
    formCreateBudget: HTMLFormElement;
  };

  private mounted(): void {
    window.scrollTo(0, 0);
    this.$store.dispatch("product/getProductsToClient");
  }

  private formatPrice(value: any): string {
    return formatPrice(value);
  }

  // Este algoritmo define cual es la licencia adecuada dependiendo de los parámetros indicados por el usuario.
  private setLicense(
    licenses: Array<any>,
    term: number,
    nodes: number,
    product: any
  ): void {
    let licenseRange = [];
    for (let index = 0; index < licenses.length; index++) {
      licenseRange.push({
        diff: Math.abs(licenses[index].licenseEquipments - nodes),
        termDiff: Math.abs(licenses[index].licenseTerm - term),
        licenseID: licenses[index].licenseID,
        licenseCost: licenses[index].licenseCost,
        licenseEquipments: licenses[index].licenseEquipments,
        licenseTerm: licenses[index].licenseTerm,
        licenseStatus: licenses[index].licenseStatus
      });
    }

    licenseRange = licenseRange.filter(
      license => license.licenseStatus !== constants.STATUS.DELETED
    );

    let currentLicense = licenseRange.sort(function(a, b) {
      return a.termDiff - b.termDiff;
    });

    currentLicense = licenseRange.sort(function(a, b) {
      return a.diff - b.diff;
    });

    product.license = currentLicense[0];
  }

  private generateBudget(): void {
    this.loadingGenerate = true;
    this.loadingDialog = true;
    for (let index = 0; index < this.selectedProducts.length; index++) {
      if (this.selectedProducts[index].license == null) {
        this.selectedProducts[index].subTotal = trunc(
          parseFloat(this.selectedProducts[index].quantity) *
            parseFloat(this.selectedProducts[index].product.productCostPerUnit),
          2
        );
      }
    }
    this.$store
      .dispatch("budget/generateBudget", {
        email: this.email,
        totalProducts: this.selectedProducts.length,
        totalEquipment: this.totalEquipments(),
        total: this.totalCost(),
        products: this.selectedProducts,
        hasProduct: this.hasProduct(),
        hasLicense: this.hasLicense()
      })
      .then(async (response: boolean) => {
        if (response) {
          this.selectedProducts = [];
          this.email = "";
          await this.$store.dispatch("product/getProductsToClient");
          this.snackbarSuccessCreate = true;
        } else {
          this.snackbarErrorCreate = true;
        }

        this.loadingDialog = false;
        this.loadingGenerate = false;
      });
  }

  private totalEquipments(): number {
    let equipments = 0;
    for (let index = 0; index < this.selectedProducts.length; index++) {
      if (this.selectedProducts[index].license !== null) {
        equipments =
          equipments +
          parseInt(this.selectedProducts[index].license.licenseEquipments);
      } else {
        equipments =
          equipments + parseInt(this.selectedProducts[index].quantity);
      }
    }
    return equipments;
  }

  private totalCost(): number {
    let cost = 0;
    for (let index = 0; index < this.selectedProducts.length; index++) {
      if (this.selectedProducts[index].license !== null) {
        cost =
          cost + parseFloat(this.selectedProducts[index].license.licenseCost);
      } else {
        cost =
          cost +
          parseFloat(this.selectedProducts[index].product.productCostPerUnit) *
            parseFloat(this.selectedProducts[index].quantity);
      }
    }
    return trunc(cost, 2);
  }

  private hasProduct(): boolean {
    let hasProduct = false;
    for (let index = 0; index < this.selectedProducts.length; index++) {
      if (this.selectedProducts[index].license == null) {
        hasProduct = true;
      }
    }
    return hasProduct;
  }

  private hasLicense(): boolean {
    let hasLicense = false;
    for (let index = 0; index < this.selectedProducts.length; index++) {
      if (this.selectedProducts[index].license !== null) {
        hasLicense = true;
      }
    }
    return hasLicense;
  }

  private get products(): Array<any> {
    const products = this.$store.getters["product/getProducts"];

    let result = products.filter(
      (product: any) => product.productStatus == constants.STATUS.ACTIVE
    );

    result = result.map((product: any) => {
      const licensesNotDeleted = product.licenses.filter(
        (license: any) => license.licenseStatus !== constants.STATUS.DELETED
      );
      return {
        product: product,
        productName: this.$t(`${product.productName}`),
        license: null,
        quantity: null,
        term: null,
        subTotal: 0,
        isLicense: licensesNotDeleted.length > 0 ? true : false
      };
    });

    result = result.map((product: any) => {
      return {
        text: `${this.$t(`${product.productName}`)}`,
        value: product
      };
    });

    return result;
  }
}
